import { ListPlus } from 'lucide-react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { PageHeader } from '@/app/layouts/PageHeader'
import { EmptyState, ErrorState } from '@/components/ui/EmptyState'
import { PostListSkeleton } from '@/components/ui/Skeleton'
import { useCurrentUser } from '@/features/auth'
import { ListEditDialog, ListRow, useMyLists } from '@/features/lists'
import { useT } from '@/i18n'

export function ListsPage() {
  const t = useT()
  const navigate = useNavigate()
  const { user } = useCurrentUser()
  const lists = useMyLists()
  const [creating, setCreating] = useState(false)

  return (
    <>
      <PageHeader title={t('nav.lists')} subtitle={user ? `@${user.username}` : undefined}>
        <div className="absolute right-3 top-2.5">
          <button
            type="button"
            onClick={() => setCreating(true)}
            aria-label={t('lists.create')}
            title={t('lists.create')}
            className="rounded-md p-2 hover:bg-surface-hover"
          >
            <ListPlus className="size-5" />
          </button>
        </div>
      </PageHeader>

      {lists.isPending ? (
        <PostListSkeleton count={3} />
      ) : lists.isError ? (
        <ErrorState message={lists.error.message} onRetry={() => lists.refetch()} />
      ) : lists.data.length === 0 ? (
        <EmptyState title={t('lists.emptyTitle')} description={t('lists.emptyBody')} />
      ) : (
        lists.data.map((list) => <ListRow key={list.id} list={list} />)
      )}

      {creating && (
        <ListEditDialog
          open
          onClose={() => setCreating(false)}
          onSaved={(list) => navigate(`/lists/${list.id}`)}
        />
      )}
    </>
  )
}
